import Component from '../app/component'

export default class ScrollUpComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      display: false
    }
  }

  init() {
    this.el.addEventListener('pointerdown', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })

    let timeout
    const scrollListener = function() {
      if (timeout) {
        return
      }
      else {
        timeout = setTimeout(() => {
          timeout = null
          const display = window.scrollY >= 1
          if (this.data.display !== display) {
            this.data.display = display
          }
        }, 30)
      }
    }.bind(this)
    window.addEventListener('scroll', scrollListener)
  }

  watchDisplay(value) {
    if (value) {
      this.el.classList.add('scrollup--display')
    }
    else {
      this.el.classList.remove('scrollup--display')
    }
  }
}
